import { useAuth0 } from "@auth0/auth0-react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { MyCheckbox } from "components";
import Action from "components/ActionPopOver";
import React, { memo, useEffect, useMemo, useState } from "react";
import AlertDialog from "../../../components/Dialog";
import MyModal from "../../../components/MyModal";
import FinanceService from "../../../Lib/API/Finance/index";
import ChargesTable from "../TransactionsTable";

import { CircularProgress } from "@mui/material";
import { ReactComponent as InstallmentIcon } from "assets/icons/recurring-icon.svg";
import MainDialog from "components/Dialog/MainDialog";
import { numberFormat } from "helper/numberFormat";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../app/App.js";
import { CheckFloatValue } from "../../../utils/functions";
import ApplyLink from "./ApplyLink";

const MOCK_SINGLE_PAYMENT = [
  {
    _id: "payment_123",
    isBulkPayment: true,

    charge_type: "payment",
    payment_status: "Paid",

    createdAt: "2026-01-20T06:30:00.000Z",

    Account: {
      id: "acc_1",
      name: "Test User",
      payment: {
        account_type: "member",
      },
    },

    Ledger: {
      name: "General Ledger",
    },

    SubLedger: {
      name: "Online Payments",
    },

    charged: 500,
    paid: 500,

    charge: {
      _id: "charge_123",
      status: "payment",
      amount: 500,
      paid: 500,
      discount: 0,
      due_date: "2026-01-25T00:00:00.000Z",

      payment: {
        status: "close",
        History: [
          {
            _id: "history_1",
            amount: 500,
            created_at: "2026-01-20T06:30:00.000Z",
            is_reversed: false,
            paymnetMethod: {
              method: "card",
            },
          },
        ],
      },
    },
  },
];

const BulkPaymentTable = (props) => {
  const { setDrawerData, setOpenModal, filters } = props;

  const { getAccessTokenSilently } = useAuth0();
  const [bulkPayments, setBulkPayments] = useState("");
  const [bulkPaymentLoading, setBulkPaymentLoading] = useState(false);

  useEffect(() => {
    getBulkPaymentsById(filters.filter.id);
  }, []);

  const getBulkPaymentsById = async (id) => {
    setBulkPayments("");
    const token = await getAccessTokenSilently();
    try {
      setBulkPaymentLoading(true);
      const res = await FinanceService.getBulkPaymentPayments(id, token);
      setBulkPayments(res);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setBulkPaymentLoading(false);
    }
  };

  return (
    <React.Fragment>
     
          {bulkPaymentLoading ? (
            <div className="w-100 text-center">
              <CircularProgress size={22} />
            </div>
          ) : (
            <Box
              style={{
                width: "100%",
                maxWidth: "100%",
                overflowX: "auto", 
              }}
            >
              <Typography variant="h6" gutterBottom component="div" />
              <Table size="small" aria-label="purchases"   sx={{
    width: "100%",
    minWidth: "100%",  
    tableLayout: "fixed"
  }}>
                <TableHead>
                  <TableRow className="MuiTableRow-root-temp">
                    <TableCell align="left" variant="body" className="border-0">
                      <span className="bulkCell_header">
                        {"charged".toUpperCase()}
                      </span>
                    </TableCell>
                    <TableCell align="left" variant="body" className="border-0">
                      <span className="bulkCell_header">
                        {"Paid".toUpperCase()}
                        {" "}
                        <Tooltip title="Paid on this bulk payment, not total paid on this charge">
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "14px",
                              height: "14px",
                              borderRadius: "50%",
                              border: "1px solid #9FA0A2",
                              fontSize: "9px",
                              fontWeight: 700,
                              cursor: "pointer",
                              verticalAlign: "middle",
                            }}
                          >
                            ?
                          </span>
                        </Tooltip>
                      </span>
                    </TableCell>
                    <TableCell align="left" variant="body" className="border-0">
                      <span className="bulkCell_header">
                        {"due".toUpperCase()}
                      </span>
                    </TableCell>
                    <TableCell align="left" variant="body" className="border-0">
                      <span className="bulkCell_header">
                        {"sub ledger / ledger".toUpperCase()}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bulkPayments?.payments?.map((item, itemIndex) => (
                    <TableRow key={item?._id ?? itemIndex} className="MuiTableRow-root-temp">
                      <TableCell
                        component="th"
                        scope="row"
                        className="finance-table border-0"
                        onClick={() => {
                          setDrawerData({
                            ...item?.transaction,
                            bulkPaymentCharge: true,
                          });
                          setOpenModal(true);
                        }}
                      >
                        <span>
                          {numberFormat({
                            number: +item?.charged,
                            decimal: 2,
                            style: "currency",
                          })}
                        </span>
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="charged-cell border-0"
                        onClick={() => {
                          setDrawerData({
                            ...item?.transaction,
                            bulkPaymentCharge: true,
                          });
                          setOpenModal(true);
                        }}
                      >
                        {" "}
                        <span>
                          {numberFormat({
                            number: +item?.paid,
                            decimal: 2,
                            style: "currency",
                          })}
                        </span>
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="charged-cell border-0"
                        onClick={() => {
                          setDrawerData({
                            ...item?.transaction,
                            bulkPaymentCharge: true,
                          });
                          setOpenModal(true);
                        }}
                      >
                        <div className="transaction-paid table-row ellipsDueAmount">
                          {isNaN(+item?.due)
                            ? numberFormat({
                                number: 0,
                                decimal: 2,
                                style: "currency",
                              })
                            : numberFormat({
                                number: +item?.due,
                                decimal: 2,
                                style: "currency",
                              })}
                        </div>{" "}
                      </TableCell>
                      <TableCell
                        className="border-0"
                        onClick={() => {
                          setDrawerData({
                            ...item?.transaction,
                            bulkPaymentCharge: true,
                          });
                          setOpenModal(true);
                        }}
                      >
                        {" "}
                        <div>
                          <div>
                            {item?.ledger
                              ? item?.ledger
                              : "-"}
                          </div>
                          <div>
                            {item?.subLedger
                              ? item?.subLedger
                              : "-"}
                          </div>
                        </div>{" "}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
     
    </React.Fragment>
  );
};

export default memo(BulkPaymentTable);
